export enum PageOrientation {
    Landscape = 'Landscape',
    Portrait = 'Portrait',
}
